import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfOrganizations } from '../../organizationSchema'

export default organizations => {
    const organizationsData = pathOr([], ['_embedded', 'hwOrganizations'], organizations)
    return { ...normalize(organizationsData, arrayOfOrganizations) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/hostelWorldParsers/hwOrganizations.js